<style scoped lang="scss">
</style>

<template>
  <section style="width: 100%">
    <input
      :type="type"
      :id="id"
      :name="name"
      :value="value"
      v-validate="rule"
      :class="{ 'form-control': true, [`form-control-${size}`]: true, 'border-danger': errors.has(name) }"
      @input="$emit('update:value', $event.target.value)"
    />
    <small v-show="errors.has(name)" class="d-block text-danger text-right">
      <font-awesome-icon :icon="faExclamationCircle" v-show="errors.has(name)" />
      {{ errors.first(name) }}
    </small>
  </section>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid'

export default {
  components: {
    FontAwesomeIcon
  },
  /**
   * To control the errorBag on parent component,
   * please remember to add provide() to parent.
   * e.g.
   *  provide () {
   *    return {
   *      parentValidator: this.$validator
   *    }
   *  }
   */
  inject: {
    parentValidator: {
      default: null
    }
  },
  created () {
    if (this.parentValidator != null) {
      this.$validator = this.parentValidator
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String
    },
    name: {
      type: String,
      default: 'text',
      required: true
    },
    value: {
      type: [String, Number]
    },
    rule: {
      type: [String, Object],
      default: 'required|alpha_num'
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  data () {
    return {
      faExclamationCircle
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputValidator.vue